module.exports = __webpack_public_path__ + "img/loading_mzcr.4f92f6d0.webp";